.card {
	border: solid 1px var(--border-primary);
	border-radius: 12px;
}

.cardSection {
	padding: 12px;
	display: flex;
	flex-direction: column;
	gap: 12px;
}

.cardSection:not(:last-child) {
	border-bottom: solid 1px var(--border-primary);
}

.cardItem {
	height: var(--body-2-line-heigth);
	display: grid;
	grid-template-columns: 40fr 60fr;
	gap: 8px;
}
